import React from 'react';
import styled from 'styled-components';
import { CommonInputCss, Error, FormControlProps } from './Common';

const Container = styled.div`
  margin: 18px 0;
`;

const StyledSelect = styled.select`
  ${CommonInputCss}
`;

const FormSelect: React.FC<FormControlProps> = ({
  placeholder,
  required,
  touched,
  error,
  children,
  ...props
}) => {
  return (
    <Container>
      <StyledSelect
        placeholder={required ? `${placeholder} *` : placeholder}
        required={required}
        {...props}
      >
        {children}
      </StyledSelect>
      {touched && error && <Error>{error}</Error>}
    </Container>
  );
};

export default FormSelect;
